import { Component } from '@angular/core';

@Component({
  selector: 'app-metal-stamping',
  templateUrl: './metal-stamping.component.html',
  styleUrls: ['./metal-stamping.component.scss']
})
export class MetalStampingComponent {
  advanceMoullding:any[] = [
    {
      title: 'Profile blanking',
      img: 'assets/images/capability/blue/metal_stamping_1.JPG',
    },
    {
      title: 'Tandom Presses Projection',
      img: 'assets/images/capability/blue/metal_stamping_2.JPG',
    },
    {
      title: 'Projection',
      img: 'assets/images/capability/blue/metal_stamping_3.JPG',
    },
    {
      title: 'Robot spotwelding lines',
      img: 'assets/images/capability/blue/metal_stamping_4.JPG',
    },
    {
      title: 'Electrical 7 Layer Furnace',
      img: 'assets/images/capability/blue/metal_stamping_5.JPG',
    },
    {
      title: '400T Press​',
      img: 'assets/images/capability/blue/metal_stamping_6.JPG',
    },
    {
      title: '5 Axis Laser​',
      img: 'assets/images/capability/blue/metal_stamping_7.JPG',
    },
    {
      title: '5000T press',
      img: 'assets/images/capability/blue/metal_stamping_8.JPG',
    },
  ]

  produtimglist:any[] = [
    {
      img: 'assets/images/capability/blue/product-image-one.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-two.png',
    },
    {
      img: 'assets/images/capability/blue/product-image-one.png',
    },    
  ]
  
  produtitemlist:any[] = [
    { 'item': 'Gear Rims'},
    { 'item': 'Heat Sinks'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'Pistons'},
    { 'item': 'Disc Valve / Port plate'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'Sleeve & Spool'},
    { 'item': 'Sub Assembly'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
  ]

  produtitemlistone:any[] = [
    { 'item': 'TiN'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'DLC'},
    { 'item': 'TiCN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'TiAlN'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
    { 'item': 'S-ACX'},
  ]
  
  rawmaterial:any[] = [
    { 'item': 'Steel: 1008, 1010, or 1018'},
    { 'item': 'Stainless Steel: 301, 304, and316/316L.'},
    { 'item': 'Copper: C110'},
    { 'item': 'Brass: 230 (85/15) & 260 (70/30)'},
  ]
  diamension:any[] = [
    { 'item': 'Upto 1500 Tonne'},
    // { 'item': 'Length–Bar stock of 3000 mm for diameters up to 20 mm'},
    // { 'item': 'Max turning length between centre 350 mm'}
  ]

  accuracy:any[] = [
     { 'item':'Blanking and Forming Dies'},
     { 'item':'Progressive Dies'},
    //  { 'item':'Size-3 microns'},
    //  { 'item':'Straightness-1 micron'},
    //  { 'item':'Roundness-1 micron'}
  ]

  surfacetreatment:any[] = [
    { 'item':'Brazing'},
    { 'item':'Nickel Plating'},
    { 'item':'Powder Coating'},
    // { 'item':'Tin Coating, Powder Coating'},
    // { 'item':'Electroless Nickel Plating (In-house)'}
 ]
}
